export const environment = {
  production: true,
  environment: 'fake-prod',
  adminBaseUrl: 'https://fake-backend.trendemon.com',
  insightsBaseUrl: 'https://fake-backend.trendemon.com',
  accountBaseUrl: 'https://fake-backend.trendemon.com',
  engagmentPreviewBaseUrl: 'https://assets-stage.trendemon.com',
  dictionariesBaseUrl: 'https://fake-backend.trendemon.com',
  mediaBaseUrl: 'https://stage-pic.trendemon.com/autotask_logo',
  mediaUrl: 'https://stage-pic.trendemon.com',
  trackingBaseUrl: 'https://fake-backend.trendemon.com',
  abmBaseUrl: 'https://fake-backend.trendemon.com',
  fetchFileUrl: 'https://stage-content.trendemon.com/dev/serve',
  getHeadersUrl: 'https://stage-content.trendemon.com/dev/headers',
  standaloneInsightsUrl: 'https://demo-insights.trendemon.com',
  standaloneJournayUrl: 'https://demo-journey.trendemon.com',
  contentUrl: 'https://content.trendemon.com',
  heapAppId: null,
  sentryEnv: 'demo',
  sentryRelease: 'dashboard-demo-BITBUCKET_BUILD_NUMBER',
  auth0: {
    clientId: 'J2tE1COjo9tnmCwGVk9VAcUFsFIYfqMA',
    domain: 'dev-ctgp35xz.auth0.com',
    audience: 'https://dev-ctgp35xz.auth0.com/api/v2/',
    mockUser: {
      name: 'John Doe',
      email: 'john.doe@cybercorp.com',
      picture: 'https://s.gravatar.com/avatar/6bc4dfbbcf5489fade790867f907afa3?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fjo.png',
      'https://trendemon.com/claims/groups': ['ac_1'],
      'https://trendemon.com/claims/permissions': ['account:admin', 'account:editor']
    },
    simple_mockUser: {
      name: 'amir',
      email: 'amir@trd.com',
      picture: 'https://s.gravatar.com/avatar/5aa5132e609580c2bcd67838afad1c96?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fam.png',
      'https://trendemon.com/claims/groups': ['nt_1', 'ac_328'],
      'https://trendemon.com/claims/permissions': ['account:admin'],
    },
    localToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkFtaXIgU2Fzc29uIiwiaWF0Ijo3Nzk0NTc2MDAwLCJleHAiOjc3OTQ1NzYwMDB9.iaYIBj3A1SuSIXjHy9tljyiD5vQ_oRkjvij3spEaglU'
  }
};
